import { CustomFieldClassTypeItem } from './CustomFieldClassTypeItem'

export const FieldDesignChange = new CustomFieldClassTypeItem({
  id: '57A54287-A5E0-4AA1-8F82-B715E305A969',
  type: 'Field Design Change',
  classType: 'FieldDesignChange',
})

export const IdentifiedFieldIssue = new CustomFieldClassTypeItem({
  id: '9EE9EB4A-F74B-4EB0-AD0C-58CD71DC1700',
  type: 'Identified Field Issue',
  classType: 'IdentifiedFieldIssue',
})

export const RequestForInformation = new CustomFieldClassTypeItem({
  id: '7B26A1DE-F812-4E8A-B97D-49D18071B721',
  type: 'Request For Information',
  classType: 'RequestForInformation',
})

export const Issue = new CustomFieldClassTypeItem({
  id: '233AEC42-E724-4B29-966D-1F2612E2717A',
  type: 'Issue',
  classType: 'Issue',
})

export const ConstructionAdminSubmittal = new CustomFieldClassTypeItem({
  id: 'CA56913F-78B5-4BD3-8F95-65E13E6CB1E9',
  type: 'Construction & Admin Submittal',
  classType: 'ConstructionAdminSubmittal',
})

export const EngineeringJudgement = new CustomFieldClassTypeItem({
  id: '7DE2C76B-D749-4608-B68C-1C45DCB191EF',
  type: 'Engineering Judgement',
  classType: 'EngineeringJudgement',
})

export const ConcreteMixDesign = new CustomFieldClassTypeItem({
  id: 'E7F64B0D-57D8-49E4-817D-523F07C97221',
  type: 'Concrete Mix Design',
  classType: 'ConcreteMixDesign',
})

export const AsphaltMixDesign = new CustomFieldClassTypeItem({
  id: 'CE93F2CC-E74D-4ED9-9C05-21A196A77976',
  type: 'Asphalt Mix Design',
  classType: 'AsphaltMixDesign',
})

export const DesignSubmittal = new CustomFieldClassTypeItem({
  id: 'E66276E6-5B74-46F2-B452-45CD00C800C7',
  type: 'Design Submittal',
  classType: 'DesignSubmittal',
})
